declare var wenji: any;

import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import _startsWith from 'lodash-es/startsWith';
import _trimStart from 'lodash-es/trimStart';
import _values from 'lodash-es/values';
import _keys from 'lodash-es/keys';
import _unset from 'lodash-es/unset';
import _isString from 'lodash-es/isString';

//App
import { ApiService } from "libraries/service/api/api.service";
import { SynchronymeService } from "../synchronyme/synchronyme.service";

@Injectable()
export class TnrService extends ApiService {
    public data: any;

    public f_insert: boolean;

    public showTnrEvent: EventEmitter<string> = new EventEmitter();
    public addedPaxEvent: EventEmitter<string> = new EventEmitter();
    public removedPaxEvent: EventEmitter<string> = new EventEmitter();
    public showTnrPending: EventEmitter<boolean> = new EventEmitter();

    private synchronymeData: any;

    constructor(
        public http: HttpClient,
        private readonly synchronyme: SynchronymeService,

    ) {
        super(http);
        this.synchronymeData = this.synchronyme.data;
        this.initRoot();
        this.initMe();
        this.initApiUrls();
    }

    public showTnr(_id: string): void {
        this.showTnrEvent.emit(_id);
    }

    public showJourneyFlag(_journeyData: any): void {
        this.addedPaxEvent.emit(_journeyData);
    }

    public hideJourneyFlag(_paxId: string, _tnrId: string): void {
        const data: any = {tnrId: _tnrId, paxId: _paxId};
        this.removedPaxEvent.emit(data);
    }

    public getTnr(_id: string): Observable<any> {

        if (this.synchronymeData.urlParams.type) {
            return this.sendToApi(this.synchronymeData.urlParams.type, _id, 'tnr', true);
        }else{
            if(_startsWith(_id, '*')){
                return this.sendToApi('file', _trimStart(_id, '*'), 'tnr', true);
            }
            return this.sendToApi('getTnr', _id, '', true);
        }

    }

    /**
     * Overwrite of parent service
     *
     * @param {any} _response        : data to store
     * @param {string} _storePath    : where to store
     * @param {boolean} _canReplace  : do I replace or not if data is steal
     */
    public additionalStore(_response: any, _storePath: string, _canReplace: boolean= false): void {

        //get response sectors
        const responseSector = _values(_response)[0].sector;
        const responseJourney = _values(_response)[0].journey;
        const key = _keys(_response)[0];

        // Store response sectors and compare sectors
        if (this.synchronyme.storeThenCompareSector(responseSector , responseJourney)){
            this.f_insert = true;
        }else{
            this.f_insert = false;
            _unset(this.response.data.tnr, key);

        }

    }

    /**
     * to be overwrited in inherited services
     * in not overwrited, return _reponse
     *
     * @param {any} _response        : data to store
     */
    public wrapData(_responseData: any): any {
        let key:string;

        const booking = _responseData.booking;

        if(_isString(booking.code)){
            key = booking.code;
        }else{
            // key = booking.code[booking.host];
            key = _values(booking.code)[0];
        }

        const object: any = {};
        object[key] = _responseData;

        return object;

     }


    public initMe(): void {
        this.group.host = wenji.synchronyme.api.group.host;
        this.group.target = wenji.synchronyme.api.group.target;
    }
}
